function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "icon_notice",
  transform: "translate(182 132.359) rotate(-180)"
}, React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M20.633,5.532a2.766,2.766,0,0,0,0-5.532H2.766A2.766,2.766,0,0,0,0,2.766v34.3a2.771,2.771,0,0,0,2.766,2.766H33.139a2.771,2.771,0,0,0,2.766-2.766V6.339a2.766,2.766,0,0,0-5.533,0V34.3H5.532V5.532Z",
  transform: "translate(0 46.26)",
  fill: "#f0f2f5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M.094,42.076A2.762,2.762,0,0,0,5.43,43.5L15.6,5.538H25V38.5a2.769,2.769,0,1,0,5.538,0V2.766A2.775,2.775,0,0,0,27.769,0H13.481V.006a2.765,2.765,0,0,0-2.668,2.052Z",
  transform: "translate(17.871 9.059)",
  fill: "#f0f2f5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M9.914,5.538A2.769,2.769,0,0,0,9.914,0H2.766a2.769,2.769,0,0,0,0,5.538Z",
  transform: "translate(10.72 58.549)",
  fill: "#f0f2f5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M5.533,2.766A2.767,2.767,0,0,0,0,2.766V101.89a2.767,2.767,0,0,0,5.533,0Z",
  transform: "translate(121.319 18.234)",
  fill: "#f0f2f5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M3.963.271a2.762,2.762,0,0,0-2.4,4.974l92.9,44.8a2.758,2.758,0,0,0,2.4-4.968Z",
  transform: "translate(45.585 82.036)",
  fill: "#f0f2f5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_59",
  "data-name": "Path 59",
  d: "M1.559,45.073a2.762,2.762,0,0,0,2.4,4.973l92.9-44.8a2.76,2.76,0,0,0-2.4-4.973Z",
  transform: "translate(45.585 0)",
  fill: "#f0f2f5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  d: "M1.559,45.077a2.762,2.762,0,0,0,2.4,4.973l92.9-44.8a2.76,2.76,0,0,0-2.4-4.973Z",
  transform: "translate(45.585 14.288)",
  fill: "#f0f2f5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_61",
  "data-name": "Path 61",
  d: "M0,115.439a2.707,2.707,0,0,0,2.767,2.64,2.706,2.706,0,0,0,2.766-2.64V2.64A2.71,2.71,0,0,0,2.767,0,2.711,2.711,0,0,0,0,2.64Z",
  transform: "translate(139.702 14.28)",
  fill: "#f0f2f5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_62",
  "data-name": "Path 62",
  d: "M5.321,1.731A2.759,2.759,0,0,0,.2,3.782a25.111,25.111,0,0,1,1.387,4.7A25.705,25.705,0,0,1,2.053,13.4,25.772,25.772,0,0,1,.2,23.007a2.759,2.759,0,0,0,5.123,2.051A31.192,31.192,0,0,0,7.585,13.4a31.031,31.031,0,0,0-.577-5.948A30.389,30.389,0,0,0,5.321,1.731Z",
  transform: "translate(160.312 52.782)",
  fill: "#f0f2f5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  d: "M5.155,1.389A2.762,2.762,0,0,0,.36,4.132c.466.812.893,1.613,1.273,2.392.4.829.772,1.659,1.1,2.478.485,1.2.905,2.408,1.262,3.613l.036.116c.335,1.165.629,2.375.87,3.618.243,1.28.432,2.542.548,3.77.109,1.193.166,2.466.166,3.815A40.486,40.486,0,0,1,4.9,31.513C4.653,32.8,4.347,34.054,4,35.247H4c-.351,1.187-.771,2.4-1.262,3.6l-.04.116c-.311.755-.662,1.544-1.06,2.363l-.064.138c-.362.744-.772,1.5-1.209,2.265a2.764,2.764,0,0,0,4.795,2.749c.477-.824.928-1.689,1.366-2.582l.087-.15c.4-.841.806-1.746,1.192-2.7l.057-.126c.531-1.321,1.01-2.7,1.43-4.122H9.281l.006-.011c.421-1.43.774-2.853,1.038-4.236a45.556,45.556,0,0,0,.83-8.621c0-1.372-.075-2.824-.22-4.329-.138-1.469-.346-2.91-.61-4.293-.259-1.354-.605-2.737-1.008-4.132l-.029-.121c-.41-1.389-.893-2.766-1.43-4.109-.386-.963-.813-1.913-1.25-2.824C6.146,3.176,5.658,2.259,5.155,1.389Z",
  transform: "translate(170.846 42.243)",
  fill: "#f0f2f5",
  fillRule: "evenodd"
}));

var SvgIconNotice = function SvgIconNotice(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 182,
    height: 132.359,
    viewBox: "0 0 182 132.359",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconNotice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_notice.b2071eb0.svg";
export { ForwardRef as ReactComponent };